import React, { useEffect, useRef } from 'react';
import BEMHelper from '@ynap/bem-helper';
import { Link } from '@ynap/router';

const bem = new BEMHelper('ProductInformation');

const renderDesignerInfo = ({
    accordionContentRef,
    designerLinkOnClick,
    designerModifier,
    designerName,
    designerSeo,
    generateListingUrl,
    isLoading,
    locale,
    name,
    nameModifier,
    plpUrlTemplate,
    promoPriceApplied,
    selectedProductBadgeModifier,
    soldOut,
}) => {
    const designerClass = bem('designer', [isLoading, designerModifier, soldOut ? 'soldOut' : '']);

    return (
        <h1 ref={accordionContentRef} className={bem('designerInfoContainer')}>
            <span className={designerClass}>
                {designerSeo ? (
                    <Link
                        to={generateListingUrl(plpUrlTemplate, {
                            LOCALE: locale,
                            SEO_URLKEYWORD: designerSeo.seoURLKeyword,
                        })}
                        onClick={designerLinkOnClick}
                    >
                        {designerName}
                    </Link>
                ) : (
                    designerName
                )}
            </span>
            <span> </span>
            <span
                className={bem('name', [
                    isLoading,
                    nameModifier,
                    promoPriceApplied,
                    selectedProductBadgeModifier,
                    soldOut ? 'soldOut' : '',
                ])}
            >
                {name}
            </span>
        </h1>
    );
};

type ProductInformationProps = {
    className?: {
        container?: string;
        designerModifier?: string;
        nameModifier?: string;
        selectedProductBadgeModifier?: string;
        soldOut?: string;
    };
    designerLinkOnClick?: (...args: unknown[]) => void;
    designerName: string;
    designerSeo: {
        seoURLKeyword: string;
    };
    generateListingUrl: (plpUrlTemplate: string, options: { LOCALE: string; SEO_URLKEYWORD: string }) => string;
    loading: boolean;
    locale: string;
    name: string;
    plpUrlTemplate: string;
    productId: string;
    promoPriceApplied: string;
    selectedProductBadgeModifier: string;
    setWidth: (width: number) => void;
    skuId: string;
};

const ProductInformation = (props: ProductInformationProps) => {
    const {
        className = {},
        designerLinkOnClick = () => { },
        designerName,
        designerSeo,
        generateListingUrl,
        loading,
        locale,
        name,
        plpUrlTemplate,
        productId,
        promoPriceApplied,
        setWidth,
        skuId,
    } = props;
    const isLoading = loading ? 'loading' : null;

    const { container = '', designerModifier = null, nameModifier = null, selectedProductBadgeModifier = null, soldOut = null } = className;
    const accordionContentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const carouselWidthCalculation = accordionContentRef?.current?.offsetWidth;
        carouselWidthCalculation && setWidth?.(carouselWidthCalculation);
    }, [accordionContentRef]);

    return (
        <div className={bem(undefined, undefined, container)}>
            {renderDesignerInfo({
                accordionContentRef,
                designerLinkOnClick,
                designerModifier,
                designerName,
                designerSeo,
                generateListingUrl,
                isLoading,
                locale,
                name,
                nameModifier,
                plpUrlTemplate,
                promoPriceApplied,
                selectedProductBadgeModifier,
                soldOut,
            })}

            {/* product/sku info for personal shopper chrome extension */}
            <meta itemProp="productID" content={productId} />
            <meta itemProp="sku" content={skuId} />
        </div>
    );
};

export default ProductInformation;
